export const mockBarChartData = [
  {
    key: '2024-01-26 00:00:00',
    value: 1,
  },
  {
    key: '2024-01-27 00:00:00',
    value: 3,
  },
  {
    key: '2024-01-28 00:00:00',
    value: 2,
  },
];

export const mockCircleChartData = [
  {
    key: 'global',
    value: 2,
  },
  {
    key: 'admin',
    value: 2,
  },
  {
    key: 'linesman',
    value: 8,
  },
  {
    key: 'inspection',
    value: 4,
  },
];

export const testDataRow = [
  {
    title: 'FILTER VESSEL JET-A',
    count: '4/5',
    time: '2h 32m',
    status: 'red',
  },
  {
    title: 'FILTER VESSEL JET-A',
    count: '4/5',
    time: '2h 32m',
    status: 'green',
  },
  {
    title: 'FILTER VESSEL JET-A',
    count: '4/5',
    time: '2h 32m',
    status: 'green',
  },
  {
    title: 'FILTER VESSEL JET-A',
    count: '4/5',
    time: '2h 32m',
    status: 'yellow',
  },
  {
    title: 'FILTER VESSEL JET-A',
    count: '4/5',
    time: '2h 32m',
    status: 'red',
  },
  {
    title: 'FILTER VESSEL JET-A',
    count: '4/5',
    time: '2h 32m',
    status: 'green',
  },
  {
    title: 'FILTER VESSEL JET-A',
    count: '4/5',
    time: '2h 32m',
    status: 'green',
  },
];

export const tableHeadMockData = [
  {
    label: 'advancedMetrics.completedDate',
    value: 'completed_at',
    is_date: true,
  },
  {
    label: 'advancedMetrics.inspectionId',
    value: 'inspection_id',
  },
  {
    label: 'advancedMetrics.facility',
    value: 'facility_name',
  },
  {
    label: 'advancedMetrics.nfc',
    value: 'nfc',
    image: true,
  },
  {
    label: 'advancedMetrics.completedBy',
    value: 'closed_by',
    is_uppercase: true,
  },
];
export const table1BodyMockData = [
  {
    id: 1,
    inspection_id: 'JF-3',
    facility: 'LavCart',
    nfc: '/assets/icons/nfc-mid.png',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 2,
    inspection_id: 'JF-3',
    facility: 'LavCart',
    nfc: '/assets/icons/nfc-mid.png',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 3,
    inspection_id: 'JF-3',
    facility: 'LavCart',
    nfc: '/assets/icons/nfc-mid.png',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 4,
    inspection_id: 'JF-3',
    facility: 'LavCart',
    nfc: '/assets/icons/nfc-mid.png',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 5,
    inspection_id: 'JF-3',
    facility: 'LavCart',
    nfc: '/assets/icons/nfc-mid.png',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 6,
    inspection_id: 'JF-3',
    facility: 'LavCart',
    nfc: '/assets/icons/nfc-mid.png',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 7,
    inspection_id: 'JF-3',
    facility: 'LavCart',
    nfc: '/assets/icons/nfc-mid.png',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
];

export const tableHead2MockData = [
  {
    label: 'corporateDashboardCard.table.headers.inspectionDate',
    value: 'inspection_date',
    is_date: true,
  },
  {
    label: 'advancedMetrics.inspections',
    value: 'inspection_id',
  },
  {
    label: 'advancedMetrics.equipmentId',
    value: 'equipment_name',
  },
  {
    label: 'advancedMetrics.facility',
    value: 'facility_name',
  },
  {
    label: 'advancedMetrics.period',
    value: 'period',
    is_uppercase: true,
  },
];

export const tableHeadPersonalMockData = [
  {
    label: 'advancedMetrics.name',
    value: 'name',
    with_avatar: true,
  },
  {
    label: 'advancedMetrics.email',
    value: 'email',
  },
  {
    label: 'advancedMetrics.roles',
    value: 'role_title',
    is_role: true,
  },
  {
    label: 'advancedMetrics.lastActivityWeb',
    value: 'last_login_at',
    is_date: true,
  },
  {
    label: 'advancedMetrics.lastActivityMob',
    value: 'last_mobile_login_at',
    is_date: true,
  },
];

export const table2BodyMockData = [
  {
    id: 1,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    inspections: 'Fuel Facility Checks',
    due_date: '04/29/24',
    period: 'Daily',
  },
  {
    id: 2,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    inspections: 'Fuel Facility Checks',
    due_date: '04/29/24',
    period: 'Daily',
  },
  {
    id: 3,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    inspections: 'Fuel Facility Checks',
    due_date: '04/29/24',
    period: 'Daily',
  },
  {
    id: 4,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    inspections: 'Fuel Facility Checks',
    due_date: '04/29/24',
    period: 'Daily',
  },
  {
    id: 5,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    inspections: 'Fuel Facility Checks',
    due_date: '04/29/24',
    period: 'Daily',
  },
  {
    id: 6,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    inspections: 'Fuel Facility Checks',
    due_date: '04/29/24',
    period: 'Daily',
  },
  {
    id: 7,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    inspections: 'Fuel Facility Checks',
    due_date: '04/29/24',
    period: 'Daily',
  },
];

export const tableHead3MockData = [
  {
    label: 'advancedMetrics.removedDate',
    value: 'status_updated_at',
    is_date: true,
  },
  {
  label: 'advancedMetrics.equipmentId',
    value: 'title',
  },
  {
    label: 'advancedMetrics.equipmentType',
    value: 'type',
  },
  {
    label: 'advancedMetrics.facility',
    value: 'facility',
  },
  {
    label: 'advancedMetrics.comment',
    value: 'decommission_comment',
  },
];

export const table3BodyMockData = [
  {
    id: 1,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    equipment_type: 'STORAGE TANK',
    removed_date: '04/29/24',
    comment: 'Seal replaced',
  },
  {
    id: 2,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    equipment_type: 'STORAGE TANK',
    removed_date: '04/29/24',
    comment: 'Seal replaced',
  },
  {
    id: 3,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    equipment_type: 'STORAGE TANK',
    removed_date: '04/29/24',
    comment: 'Seal replaced',
  },
  {
    id: 4,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    equipment_type: 'STORAGE TANK',
    removed_date: '04/29/24',
    comment: 'Seal replaced',
  },
  {
    id: 5,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    equipment_type: 'STORAGE TANK',
    removed_date: '04/29/24',
    comment: 'Seal replaced',
  },
  {
    id: 6,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    equipment_type: 'STORAGE TANK',
    removed_date: '04/29/24',
    comment: 'Seal replaced',
  },
  {
    id: 7,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    equipment_type: 'STORAGE TANK',
    removed_date: '04/29/24',
    comment: 'Seal replaced',
  },
];

export const tableHead4MockData = [
  {
    label: 'advancedMetrics.closeDate',
    value: 'closed_at',
    is_date: true,
  },
  {
    label: 'advancedMetrics.equipmentId',
    value: 'equipment_id',
  },
  {
    label: 'advancedMetrics.equipmentType',
    value: 'equipment_type',
  },
  {
    label: 'advancedMetrics.facility',
    value: 'facility_name',
  },
  {
    label: 'advancedMetrics.discrepancy',
    value: 'discrepancy',
  },
  {
    label: 'advancedMetrics.correctiveAction',
    value: 'action',
  },
  {
    label: 'advancedMetrics.closeBy',
    value: 'closed_by',
  },
];

export const table4BodyMockData = [
  {
    id: 1,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    discrepancy:
      'Fire Extinguishers - Safety / Tamper Seals: seal  Fire Extinguishers - Safety / Tamper Seals: seal missing',
    corrective_action: 'New motor was installed on 12/14/20',
    equipment_type: 'STORAGE TANK',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 2,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    discrepancy:
      'Fire Extinguishers - Safety / Tamper Seals: seal  Fire Extinguishers - Safety / Tamper Seals: seal missing',
    corrective_action: 'New motor was installed on 12/14/20',
    equipment_type: 'STORAGE TANK',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 3,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    discrepancy:
      'Fire Extinguishers - Safety / Tamper Seals: seal  Fire Extinguishers - Safety / Tamper Seals: seal missing',
    corrective_action: 'New motor was installed on 12/14/20',
    equipment_type: 'STORAGE TANK',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 4,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    discrepancy:
      'Fire Extinguishers - Safety / Tamper Seals: seal  Fire Extinguishers - Safety / Tamper Seals: seal missing',
    corrective_action: 'New motor was installed on 12/14/20',
    equipment_type: 'STORAGE TANK',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 5,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    discrepancy:
      'Fire Extinguishers - Safety / Tamper Seals: seal  Fire Extinguishers - Safety / Tamper Seals: seal missing',
    corrective_action: 'New motor was installed on 12/14/20',
    equipment_type: 'STORAGE TANK',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 6,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    discrepancy:
      'Fire Extinguishers - Safety / Tamper Seals: seal  Fire Extinguishers - Safety / Tamper Seals: seal missing',
    corrective_action: 'New motor was installed on 12/14/20',
    equipment_type: 'STORAGE TANK',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
  {
    id: 7,
    equipment_id: 'JF-3',
    facility: 'LavCart',
    discrepancy:
      'Fire Extinguishers - Safety / Tamper Seals: seal  Fire Extinguishers - Safety / Tamper Seals: seal missing',
    corrective_action: 'New motor was installed on 12/14/20',
    equipment_type: 'STORAGE TANK',
    close_date: '04/29/24',
    close_by: 'Matthew Sanzobrin',
  },
];

export const tableHeadOpenMockData = [
  {
    label: 'advancedMetrics.createDate',
    value: 'created_at',
    is_date: true,
  },
  {
        label: 'advancedMetrics.equipmentId',
    value: 'equipment_title',
  },
  {
    label: 'advancedMetrics.equipmentType',
    value: 'equipment_type',
  },
  {
    label: 'advancedMetrics.facility',
    value: 'facility_name',
  },
  {
    label: 'advancedMetrics.comment',
    value: 'comment',
  },
];

export const tableHead5MockData = [
  {
    label: 'advancedMetrics.typeEquipment',
    value: 'title',
  },
  {
    label: 'advancedMetrics.count',
    value: 'count',
  },
  {
    label: 'advancedMetrics.nfcChipEnabled',
    value: 'with_nfc',
  },
  {
    label: 'advancedMetrics.inspectionsDoneWithChipLastMonth',
    value: 'percent_done_w_chip_last_month',
    is_percent: true,
  },
  {
    label: 'advancedMetrics.inspectionsDoneWithChipThisMonth',
    value: 'percent_done_w_chip_this_month',
    is_percent: true,
  },
];

export const tableHead6MockData = [
  {
    label: 'advancedMetrics.name',
    value: 'name',
    with_avatar: true,
  },
  {
    label: 'advancedMetrics.email',
    value: 'email',
  },
  {
    label: 'advancedMetrics.averageTime',
    value: 'average_time',
  },
];
